<template>
  <div>


    <v-dialog width = "900" scrollable  persistent
    v-model="modals.creator">
     <creatorWrapper  :creator="creator" :modals="modals" :tasks="tasks" ></creatorWrapper>
    </v-dialog>



    <v-dialog max-width="450"  persistent    v-model="tasks.deleteTask.modal">
    <deleteTask  :tasks="tasks"  ></deleteTask>
    </v-dialog>



<v-container fluid >
    <v-layout d-flex>
    <v-card>
      <v-toolbar height="42"     flat>
        <v-toolbar-title style="color:#273C51;font-size:1.6em"> Задания для страниц ({{tasks.tasksList.length}}) </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-btn  @click="createNewTask()" flat color="#4A76A8"> <v-icon left> mdi-plus</v-icon> Создать задание</v-btn>
      </v-toolbar>
    <v-card-text>

      <div v-if="tasks.loading === true" class="text-xs-center" style="marginTop:50px" >

        <v-progress-circular
          :size="70"
          :width="7"
          color="#4A76A8"
          indeterminate
        ></v-progress-circular>

      </div>


   <div v-if="tasks.tasksList.length<=0"  style="padding-top:50px" >
   <div class="text-xs-center"><span  style="font-size:1.3em; color:#858585">  Список заданий пуст, вы можете создать новое задание.</span></div>

   </div>


     <tasksList :creator="creator" :modals="modals"   :tasks='tasks'> </tasksList>
   <div @click="createNewTask()" class="text-xs-center">  <v-btn     color="#4A76A8" class="white--text"><v-icon left>mdi-database-plus</v-icon>Новое задание </v-btn>  </div>










    </v-card-text>


    </v-card>

    </v-layout>
</v-container >


<v-dialog  v-model="tasks.modals.resources" max-width="900" min-width="900" max-height="500"  persistent  scrollable      >
<resources :tasks="tasks"> </resources>
</v-dialog>


<v-dialog v-if="tasks.modals.msg"  v-model="tasks.modals.msg"  width="1200"    scrollable  >
<msg  :tasks="tasks"> </msg>
</v-dialog>


</div>
</template>




<script>
import axios from 'axios'
import tasksList from './tasksList.vue'
import creatorWrapper from './creator/creatorWrapper.vue'
import deleteTask from './deleteTask.vue'

import resources from './taskParams/resources.vue'
import msg from './taskParams/msg.vue'

 export default {
 components:{tasksList,creatorWrapper,deleteTask,resources,msg },
 data(){
   return {
   modals:{
     creator:false,
   },
   tasks:{
     itemka: [],
     loading:true,
     modals: {
       msg: false,
       resourcesTest:false,
       logs:false,
       resources:false,
     },
     timeoutUpdate: '',
     deleteTask: {
       modal : false,
       taskId: {},
     },
     tasksList: [],

     task:{
      startUpdateRes: '',
      modal : false,

      info: {},
      timeoutUpdate: '',
      selectedTaskId: '',
      accounts:[],
      accountsSelected: [],
      resources: {
        foundData:{
         selector: false,
         foundIds: [],
         displayIds: [],
         selectedIds: [],
         offset: 0,
         selectAll: false
       },
       foundData1:{
        selector: false,
        foundIds: [],
        displayIds: [],
        selectedIds: [],
        offset: 0,
        selectAll: false
      },
       foundDataDone:{
        selector: false,
        foundIds: [],
        displayIds: [],
        selectedIds: [],
        offset: 0,
        selectAll: false
      },
      foundDataMinus_traff:{
       selector: false,
       foundIds: [],
       displayIds: [],
       selectedIds: [],
       offset: 0,
       selectAll: false
     },
      foundDataBots:{
       selector: false,
       foundIds: [],
       displayIds: [],
       selectedIds: [],
       offset: 0,
       selectAll: false
     },
     },
      actions:{
        friendRequest:{
          conditions:{
            modal:false
          }
        },
        messageSend:{
          conditions:{
            modal:false
          }
        },
        likeAvatar:{
          conditions:{
            modal:false
          }
        },
        unFriend:{
          conditions:{
            modal:false
          }
        },
      },
      logs:[],
params:{
        resourcesTimeout:{
          min: 2,
          max: 90,
          range: [1, 1]
        },
        actionsTimeout:{
          min: 5,
          max: 90,
          range: [1, 1]
        },
        traffControl:{
          blockedToBots:true,
          removeClosedMsg:false,
          removeClosedFriendsReq:false,
          minWomen:false,
          minMen:false,
          onlyOnline:false,
          maxOffline:10,
        },
},
      name: ""
    }

   },

creator:{
creationPath: "/tasks/taks_creator.php",   // "tasks/edit_task.php"
taskId: "",
isEditor:false,
panel:[false,false,false,false,false],

  filters:{
    all:[],
    selected:[],
  },

  procesess: {
    procResults: {
      items: [],
      selected: [],
      active: false,
    },
    procResultsLabel: "Привязать результаты процессов",
    procUpdates: {
      items: [],
      selected: [],
      active: true,
    },
    procUpdatesLabel: "Привязать результаты обновлений процессов",
    contentType: 'pages',
  },
  ui:{
    createLoading: false
  },
  active: null,
  sb:{
  snackbar: false,
  color: 'success',
  text: ''
},
newTask:{
  modals: {
    message: false,
  },
  name: '',
  accounts: [],
  accGroupId: '1',
  accGroupsList: [],
  accountsAll:[],

 preActions:{
   activated:false,

   privat:{
     is:false,
     options:{
       openProfile:{
         selected: 0,
         options:[{text:"не заданно",value:0},{text:"Закрытый профиль",value:1},{text:"Открытый профиль",value:2}],
       },
       msgRecive:{
         selected: 0,
         options:[{text:"не заданно",value:0},{text:"Все пользователи",value:1,vk_value:'all'},{text:"Только друзья аккаунта",value:2,vk_value:'friends'},{text:"Друзья друзей",value:3,vk_value:'friends_of_friends'},{text:"Никто",value:4,vk_value:'nobody'}],
       },
       whoCanPost:{
         selected: 0,
         options:[{text:"не заданно",value:0},{text:"Все пользователи",value:1,vk_value:'all'},{text:"Только друзья аккаунта",value:2,vk_value:'friends'},{text:"Только пользователь",value:3,vk_value:'only_me'}],
       },
       whoCanComment:{
         selected: 0,
         options:[{text:"не заданно",value:0},{text:"Все пользователи",value:1,vk_value:'all'},{text:"Только друзья аккаунта",value:2,vk_value:'friends'},{text:"Только пользователь",value:3,vk_value:'only_me'}],
       },
       whoCanSeeOthersComments:{
         selected: 0,
         options:[{text:"не заданно",value:0},{text:"Все пользователи",value:1,vk_value:'all'},{text:"Только друзья аккаунта",value:2,vk_value:'friends'},{text:"Только пользователь",value:3,vk_value:'only_me'}],
       },
       whoCanSeeOthersPosts:{
         selected: 0,
         options:[{text:"не заданно",value:0},{text:"Все пользователи",value:1,vk_value:'all'},{text:"Только друзья аккаунта",value:2,vk_value:'friends'},{text:"Только пользователь",value:3,vk_value:'only_me'}],
       },
     }
   },
   status:{
     is:false,
     text:"",
   },
   repost:{
     is:false,
     text:"",
     attachment:"",
     pin:0,
     close_comments:0,
     add_like:0,
     make_comment:{is:0,text:''},

   },
   post:{
     is:false,
     text:"",
     pin:0,
     close_comments:0,
     add_like:0,
     make_comment:{is:0,text:''},

   },
 },

  actions:{
  friendRequest:   {
      type: 'friendRequest',
      activated: false,
      text: "",
      afterAccept:{
        is:false,
        text: "",
      },
    },
    messageSend:   {
        type: 'messageSend',
        activated: false,
        text:"",
        attachments: "",
        text2: "",
        deletAfter: false,
        repostPost:0,
        repostRepost:0,
      },
  likeAvatar:   {
          type: 'likeAvatar',
          activated: false,
          conditions:{
            modal: false,
            activated: false,
            type: "pages",
          }
        },
  postActions: {
          type: 'postActions',
          activated: false,
          conditions:{
            modal: false,
            activated: false,
            type: "pages",
              }
              },
        unFriend:   {
                type: 'unFriend',
                activated: false,
                conditions:{
                  modal: false,
                  activated: false,
                  type: "pages",
                }
              },
  },
  resources:"",
  traffControl:{
    blockedToBots:true,
    removeClosedMsg:false,
    removeClosedFriendsReq:false,
    minWomen:false,
    minMen:false,
    onlyOnline:false,
    maxOffline:10,
  },
  resourcesTimeout:{
    min: 0,
    max: 90,
    range: [1, 1]
  },
  actionsTimeout:{
    min: 0,
    max: 90,
    range: [1, 1]
  },
  accountSettings:{
    mode: 1,
    options: [{value:1, text:"Выполнять задание рандомно с одного аккаунта"},{value:2, text:"Выполнять задание с каждого  аккаунта по порядку"}],
  },
  stopLimit: null,
  stopBlock: true,
  replaceThenLimit: true,
  replaceThenBlock: null,

sequentialBlock:{
is:false,
accCount:5,

stopTask:true,
},

  allActionsImportant: true,
  exceptDuble: true,
}
},


   }
 },
methods: {
createNewTask(){
this.creator.isEditor = false
this.creator.creationPath = "/tasks/taks_creator.php"
this.creator.panel = [true,true,true,true]
this.modals.creator = true


},

  tasksData: function(){

    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/task_for_export.php', {
         method: 'POST',
         data: {
           contentType: 'pages'
         }
       })
       .then( response => {
         this.tasks.loading = false
            response.data.forEach(
           (item,i,arr)=>{
             item.status = JSON.parse(item.status)
           }
         )
         this.tasks.tasksList = response.data
       })

  },
},
mounted(){
   this.tasksData()
},
beforeDestroy() {
clearTimeout(this.tasks.timeoutUpdate);
}


 }
</script>



<style>
#tasks_wrapper {
  max-width: 850px;
  min-width: 850px;
  margin-top: 15px;
  background-color: white;
  min-height: 100vh;
  border: solid 1px #E3E4E8;
  border-radius: 2px
}
</style>
